const INIT_FILTER_VALUE = {
    national_id: null,
    full_name: null,
    advance_filter: false,
  };
  
  const state = () => {
    return { ...INIT_FILTER_VALUE };
  };
  
  // actions
  const actions = {
    clearStore({ commit }) {
      commit("clearStore");
    },
    setStore({ commit }, store) {
      commit("setStore", store);
    },
    // START: national_id
    setNationalId({ commit }, national_id) {
      commit("setNationalId", national_id);
    },
    // END: national_id
    // START: fullName
    setFullName({ commit }, full_name) {
      commit("setFullName", full_name);
    },
    // END: fullName
    //   START: advanceFilter
    setAdvanceFilter({ commit }, boo) {
      commit("setAdvanceFilter", boo);
    },
    toggleAdvanceFilter({ commit }) {
      commit("toggleAdvanceFilter");
    },
    //   END: advanceFilter
  };
  
  // mutations
  const mutations = {
    clearStore(state) {
      state = { ...INIT_FILTER_VALUE };
    },
    setStore(state, store) {
      Object.assign(state, store);
    },
    // START: national_id
    setNationalId(state, national_id) {
      state.national_id = national_id;
    },
    // END: national_id
    // START: fullName
    setFullName(state, full_name) {
      state.full_name = full_name;
    },
    // END: fullName

  };
  
  // getters
  const getters = {
    national_id: (state) => state.national_id,
    full_name: (state) => state.full_name,
    getAllFilter: (state) => {
      if (state.advance_filter) return state;
      const commonFilter = {
          ...state,
      };
      return commonFilter;
    },
    getCommonFilter: (state) => {
      const commonFilter = {
        national_id: state.national_id,
        full_name: state.full_name,
      };
      return commonFilter;
    },
    getFilterSummaryArray: (state) => {
      let prepareState = { ...state };
      let result = [];
  
      // national_id
      if (prepareState.national_id)
        result.push({
          title: "เลขบัตรประชาชน",
          text: prepareState.national_id,
        });
      // full_name
      if (prepareState.full_name)
        result.push({
          title: "ชื่อ - นามสกุล",
          text: prepareState.full_name,
        });
      return result;
    },
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
  